
const StudentRow = ({name, email, dob}) =>  (
    <tr>
        <td>{name}</td>
        <td>{email}</td>
        <td>{dob}</td>
    </tr>
);
  
export default StudentRow;